<!-- Brand Logo -->
<a [routerLink]="['/']" class="brand-link amt-brand-link text-center"
    style="display: flex; justify-content: center; align-items: center; padding: 10px 0;">
    <img src="assets/img/AMT.png" alt="AMT Logo" class="brand-image"
        style="opacity: 0.9; float: none; margin: 0; height: 70px; width: 75px; max-height: 75px;">
</a>

<!-- Sidebar -->
<div class="sidebar">
    <!-- Sidebar user panel -->

    <!-- Sidebar Menu -->
    <nav class="mt-1" style="overflow: hidden;">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            <app-menu-item *ngFor="let item of menu" [menuItem]="item" />
        </ul>
    </nav>
</div>